import * as React from "react";

export const IconDelete = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 10.5C10.5523 10.5 11 10.9477 11 11.5V17.5C11 18.0523 10.5523 18.5 10 18.5C9.44772 18.5 9 18.0523 9 17.5V11.5C9 10.9477 9.44772 10.5 10 10.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 10.5C14.5523 10.5 15 10.9477 15 11.5V17.5C15 18.0523 14.5523 18.5 14 18.5C13.4477 18.5 13 18.0523 13 17.5V11.5C13 10.9477 13.4477 10.5 14 10.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.29289 3.79289C9.48043 3.60536 9.73478 3.5 10 3.5H14C14.2652 3.5 14.5196 3.60536 14.7071 3.79289C14.8946 3.98043 15 4.23478 15 4.5V5.5H17V4.5C17 3.70435 16.6839 2.94129 16.1213 2.37868C15.5587 1.81607 14.7956 1.5 14 1.5H10C9.20435 1.5 8.44129 1.81607 7.87868 2.37868C7.31607 2.94129 7 3.70435 7 4.5V5.5H9V4.5C9 4.23478 9.10536 3.98043 9.29289 3.79289ZM5 5.5H3C2.44772 5.5 2 5.94772 2 6.5C2 7.05228 2.44772 7.5 3 7.5H4V20.5C4 21.2957 4.31607 22.0587 4.87868 22.6213C5.44129 23.1839 6.20435 23.5 7 23.5H17C17.7957 23.5 18.5587 23.1839 19.1213 22.6213C19.6839 22.0587 20 21.2957 20 20.5V7.5H21C21.5523 7.5 22 7.05228 22 6.5C22 5.94772 21.5523 5.5 21 5.5H19C19.5523 5.5 20 5.94772 20 6.5V7.5H18V20.5C18 20.7652 17.8946 21.0196 17.7071 21.2071C17.5196 21.3946 17.2652 21.5 17 21.5H7C6.73478 21.5 6.48043 21.3946 6.29289 21.2071C6.10536 21.0196 6 20.7652 6 20.5V7.5H4V6.5C4 5.94772 4.44772 5.5 5 5.5Z"
      fill="currentColor"
    />
    <path d="M19 5.5H17H15H9H7H5C4.44772 5.5 4 5.94772 4 6.5V7.5H6H18H20V6.5C20 5.94772 19.5523 5.5 19 5.5Z" fill="currentColor" />
  </svg>
);
